import {

  CORE_LOAD_ALL_PROFILE_REQUEST,
  CORE_LOAD_ALL_PROFILE_SUCCESS,

  CORE_LOAD_PROFILE_INFO_REQUEST,
  CORE_LOAD_PROFILE_INFO_SUCCESS,

} from '../../types'

const initialState = []
export default {
  profileList: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_PROFILE_REQUEST:
        return initialState
      case CORE_LOAD_ALL_PROFILE_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
  profileInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_PROFILE_INFO_REQUEST:
        return initialState
      case CORE_LOAD_PROFILE_INFO_SUCCESS:
        if (action.payload)
          return action.payload
        else return {}
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/profile/reducer.js